import { Component, OnInit, ViewEncapsulation, Inject, OnDestroy } from "@angular/core";
import { MatDialog, MAT_DIALOG_DATA, MatDialogRef } from "@angular/material";
import { BrandService } from "../../shared/services/brand/brand.service";
import { Observable } from "rxjs/Observable";
import "rxjs/add/operator/debounceTime";
import {
  FormGroup,
  FormBuilder,
  Validators
} from "@angular/forms";
import {
  Brand,
  BrandMaster,
  BrandCategory
} from "../../shared/interface/brand";
import { Site } from "../../shared/interface/site";
import { Zone } from "../../shared/interface/zone";
import "rxjs/add/operator/debounceTime";
import { Subject } from 'rxjs/Subject';
import { takeUntil } from "rxjs/operators";

@Component({
  selector: "app-brands",
  templateUrl: "./brands.component.html",
  styleUrls: ["./brands.component.scss"],
  encapsulation: ViewEncapsulation.None
})
export class BrandsComponent implements OnInit , OnDestroy{
  private subject: Subject<string> = new Subject();
  private _unsubscribeAll  : Subject<any> = new Subject<any>();
  searchLoading = 0;
  dataSource: Brand[];

  constructor(public dialog: MatDialog, private brandService: BrandService) { }

  ngOnInit() {
    this.setList();
    this.brandService.getAction().pipe(takeUntil(this._unsubscribeAll)).subscribe(data => {
      if (["create", "update"].includes(data.action)) {
        this.setList();
      }
    });
    this.subject.debounceTime(400).pipe(takeUntil(this._unsubscribeAll)).subscribe(filterTerm => {
      this.setList("?where[brandName]=" + filterTerm);
    });
  }

  ngOnDestroy(){
    this._unsubscribeAll.next(null);
    this._unsubscribeAll.complete();
  }

  setList(filter = "") {
    this.brandService.list(filter).pipe(takeUntil(this._unsubscribeAll)).subscribe(
      res => {
        this.dataSource = res;
        this.searchLoading = 0;
      },
      err => { }
    );
  }

  openBrandDialog = (data = {}) => {
    this.dialog.open(BrandDialog, {
      data: data,
      height: "auto",
      width: "400px",
      panelClass: "full-modal"
    });
  };

  openBrandMapDialog = (data = {}) => {
    this.dialog.open(BrandMapDialog, {
      data: data,
      height: "auto",
      width: "600px",
      panelClass: "full-modal"
    });
  }

  delete(_id: string) {
    if (confirm("Are you sure you want to remove this brand.") == false) {
      return false;
    }

    let temp = this.dataSource;
    this.dataSource = this.dataSource.filter(item => item["_id"] !== _id);
    this.brandService.delete(_id).pipe(takeUntil(this._unsubscribeAll)).subscribe(
      r => { },
      e => {
        this.dataSource = temp;
      }
    );
  }

  filterData(filterTerm) {
    this.subject.next(filterTerm);
    this.searchLoading = 1;
  }
}

@Component({
  selector: "brand-dialog",
  templateUrl: "brand.dialog.html"
})
export class BrandDialog implements OnDestroy {
  brandForm: FormGroup;
  brandMasterlist: BrandMaster[] = [];
  brandCategoryList: BrandCategory[] = [];
  newFrom = [];
  isSubmitted: number = 0;
  private _unsubscribeAll  : Subject<any> = new Subject<any>();
  brandMaster: BrandMaster[] = [];
  brandCategory: BrandCategory[] = [];

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    public brandService: BrandService,
    public fb: FormBuilder,
    public dialogRef: MatDialogRef<BrandDialog>
  ) {

    data = this.parseData(data);
    this.createForm(data);

    this.brandForm.controls["brandMasterId"].valueChanges
      .debounceTime(400).pipe(takeUntil(this._unsubscribeAll))
      .subscribe(name => {
        // this.kpiGroups = [];
        this.brandService.brandMasterList(name).pipe(takeUntil(this._unsubscribeAll)).subscribe(r => {
          if (r) {
            this.brandMaster = r;
          }
        });
      });

    this.brandForm.controls["brandCategoryId"].valueChanges
      .debounceTime(400).pipe(takeUntil(this._unsubscribeAll))
      .subscribe(name => {
        this.brandService.brandCategoryList(name).pipe(takeUntil(this._unsubscribeAll)).subscribe(r => {
          if (r) {
            this.brandCategory = r;
          }
        });
      });
  }

  ngOnDestroy(){
    this._unsubscribeAll.next(null);
    this._unsubscribeAll.complete();
  }

  createForm(data: any) {
    this.brandForm = this.fb.group({
      _id: [data._id],
      brandMasterId: [data.brandName, Validators.required],
      brandCategoryId: [data.brandCategoryName, Validators.required]
    });
  }

  parseData(data: any) {
    if (data && data._id) {
      this.brandMaster.push({
        _id: data.brandMasterId,
        brandName: data.brandName
      });
      this.brandCategory.push({
        _id: data.brandCategoryId,
        brandCategoryName: data.brandCategoryName
      });
      return data;
    }

    data = {
      _id: "",
      brandMasterId: "",
      brandCategoryId: ""
    };

    return data;
  }

  onSubmit(form: any) {
    let body: any = {}
    body.brandId = form._id;
    this.isSubmitted = 1;

    //get brandMasterId
    this.brandMaster.forEach((val, i) => {
      if (val.brandName == form.brandMasterId) {
        body.brandMasterId = val._id;
      }
    });

    //get brandCategoryId
    this.brandCategory.forEach((v, i) => {
      if (v.brandCategoryName == form.brandCategoryId) {
        body.brandCategoryId = v._id;
      }
    });

    //Create Brand
    if (body.brandId == "") {
      this.brandService.create(body).pipe(takeUntil(this._unsubscribeAll)).subscribe(
        res => {
          this.brandService.sendAction("create", 0);
          this.dialogRef.close();
          this.isSubmitted = 0;
        },
        err => {
          this.isSubmitted = 0;
        }
      );
    } else {
      //Update Brand
      this.brandService.update(body).pipe(takeUntil(this._unsubscribeAll)).subscribe(
        res => {
          this.brandService.sendAction("update", form._id);
          this.dialogRef.close();
          this.isSubmitted = 0;
        },
        err => {
          this.isSubmitted = 0;
        }
      );
    }
  }
}

@Component({
  selector: 'brand-map-dialog',
  templateUrl: 'brand-map.dialog.html'
})
export class BrandMapDialog implements OnDestroy{
  brandMapForm: FormGroup;
  dataSite$: Observable<Site[]>;
  //datazone$: Observable<Zone[]>;
  private _unsubscribeAll  : Subject<any> = new Subject<any>();
  zonesList: Zone[] = [];
  zones = [];
  zoneIds = [];
  isSubmitted: number = 0;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    private brandService: BrandService,
    public fb: FormBuilder,
    public dialogRef: MatDialogRef<BrandMapDialog>
  ) {
    data = this.parseData(data);
    this.createForm(data);

    this.dataSite$ = this.brandService.siteList().pipe(takeUntil(this._unsubscribeAll));
    //this.datazone$ = this.brandService.zoneList();

    //commented to create multiple checkbox dropdown for zone selection
    // this.brandMapForm.controls['siteId'].valueChanges
    //   .debounceTime(400)
    //   .subscribe(name => {
    //     this.zones = [];
    //   });

    //commented to create multiple checkbox dropdown for zone selection
    // this.brandMapForm.controls['zones'].valueChanges
    //   .debounceTime(400)
    //   .subscribe(name => {
    //     this.brandService.zoneList(name, this.brandMapForm.controls['siteId'].value).subscribe(res => {
    //       if (res) {
    //         this.zonesList = res;
    //       }
    //     });
    //   });

  }

  ngOnDestroy(){
    this._unsubscribeAll.next(null);
    this._unsubscribeAll.complete();
  }

  getZoneList() {
    this.brandService.zoneList("", this.brandMapForm.controls['siteId'].value).pipe(takeUntil(this._unsubscribeAll)).subscribe(res => {
      if (res) {
        this.zonesList = res;
      }
    });
  }

  createForm = (data: any) => {
    this.brandMapForm = this.fb.group({
      _id: [data._id],
      siteId: ["", Validators.required],
      mappedFullSite: [false],
      zones: []
    });
  }

  parseData(data: any) {
    if (data && data._id) {
      return data;
    }
    return {
      _id: "0",
      siteId: "",
      mappedFullSite: false,
      zones: []
    }
  }

  //commented to create multiple checkbox dropdown for zone selection
  //On select of autocomplete
  // onZoneSelect(zone: any) {
  //   let keepGoing = true;

  //   this.zones.forEach((v, i) => {
  //     if (keepGoing) {
  //       if (v._id == zone._id) {
  //         keepGoing = false;
  //         this.brandMapForm.controls['zones'].setValue('');
  //       }
  //     }
  //   });

  //   if (keepGoing) {
  //     this.zones.push(zone);
  //     this.brandMapForm.controls['zones'].setValue('');
  //   }
  // }

  // remove(zone: any): void {
  //   let index = this.zones.indexOf(zone);

  //   if (index >= 0) {
  //     this.zones.splice(index, 1);
  //   }
  // }

  onSubmit(form: any) {
    //commented to create multiple checkbox dropdown for zone selection
    // let body: any = {};

    // body.siteId = form.siteId;
    // body.mappedFullSite = (form.mappedFullSite) ? 1 : 0;
    // body.zones = [];


    // if (body.mappedFullSite == 0) {
    //   this.zones.forEach((v, i) => {
    //     body.zones.push(v._id);
    //   });
    // }

    //check if full site is mapped
    this.isSubmitted = 1;
    form.mappedFullSite = (form.mappedFullSite) ? 1 : 0;
    form.zones = (form.mappedFullSite ? [] : form.zones);

    this.brandService.createMap(form._id, form).pipe(takeUntil(this._unsubscribeAll)).subscribe(res => {
      this.dialogRef.close();
      this.brandService.sendAction("create", "");
      this.isSubmitted = 0;
    }, (err) => {
      this.isSubmitted = 0;
    });
  }

  delete(brandId, mapped) {
    if (
      confirm("Are you sure you want to remove this Brand mapping.") == false
    ) {
      return false;
    }

    this.data.mapped = this.data.mapped.filter(m => m.siteId !== mapped.siteId)

    mapped.zones.forEach((v, i) => {
      this.zoneIds.push(v.zoneId);
    });
    mapped.zones = this.zoneIds;

    this.brandService.deleteMapping(brandId, mapped).pipe(takeUntil(this._unsubscribeAll)).subscribe(res => {
      this.brandService.sendAction('update', "");
    }, (err) => { });
  }
}





// WEBPACK FOOTER //
// D:/Xpand-Dubai/xpand_retail_int/Customers/app/src/app/profile/brands/brands.component.ts